/**
 * Non-redeemable invitation link markers for template preview/test emails.
 * Must match server `server/utils/companyInvitationPlaceholder.ts`.
 */
export const INVITATION_EMAIL_PLACEHOLDER_TOKEN = '__sevv_invitation_placeholder__'
export const INVITATION_EMAIL_PLACEHOLDER_COMPANY = '__sevv_none__'

export function isPlaceholderInvitationQuery(token: string | null, company: string | null): boolean {
  return (
    token === INVITATION_EMAIL_PLACEHOLDER_TOKEN && company === INVITATION_EMAIL_PLACEHOLDER_COMPANY
  )
}
